import React, { useState, useEffect } from "react";
import { Modal, Button, message } from "antd";
import { mixPostV1, mixGetV1 } from "services/mixin";
import { useNavigate } from "react-router-dom";

const AffiliatePage = ({ onNext }: { onNext: () => void }) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [showRegistrationSuccessfulModal, setShowRegistrationSuccessfulModal] = useState(false);
	const [showAffiliatePolicyModal, setShowAffiliatePolicyModal] = useState(false);
	const [showAffiliateProgram, setShowAffiliateProgram] = useState(false);
	const [agreePolicy, setAgreePolicy] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const [alreadyJoined, setAlreadyJoined] = useState(false);
	const [loadingProfile, setLoadingProfile] = useState(true);
	const [searchTerm, setSearchTerm] = useState("");
	const [isSearching, setIsSearching] = useState(false);

	const toggleModal = (open: boolean) => {
		setModalOpen(open);
	};
	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
		setIsSearching(true);

		// Giả lập delay tìm kiếm
		setTimeout(() => {
			setIsSearching(false);
		}, 800);
	};

	// Đóng modal khi nhấn phím Escape
	useEffect(() => {
		const handleKeyUp = (e: KeyboardEvent) => {
			if (e.key === "Escape") setModalOpen(false);
		};
		window.addEventListener("keyup", handleKeyUp);
		return () => window.removeEventListener("keyup", handleKeyUp);
	}, []);

	// const newAff = () => {
	// 	setShowAffiliateProgram(false);
	// 	setShowRegistrationSuccessfulModal(true);
	// };

	useEffect(() => {
		let interval: NodeJS.Timer;

		const checkAffiliateStatus = async () => {
			try {
				const res = await mixGetV1("/api/v1/fe/customer/profile", { auth: true });
				if (res?.status && res.data?.contact_affiliate?.status === 1) {
					setAlreadyJoined(true);
					onNext?.();
					clearInterval(interval);
				}
			} catch (err) {
				console.error(err);
			}
			finally {
				setLoadingProfile(false);
			}
		};

		checkAffiliateStatus();
		interval = setInterval(checkAffiliateStatus, 1000);

		return () => clearInterval(interval);
	}, [onNext]);

	// useEffect(() => {
	// 	const checkAffiliateStatus = async () => {
	// 		try {
	// 			const res = await mixGetV1("/api/v1/fe/customer/profile", { auth: true });
	// 				if (res?.status && res.data?.contact_affiliate?.status === 1) {
	// 					setAlreadyJoined(true);
	// 					onNext?.(); // gọi next ngay
	// 				}
	// 		} catch (err) {
	// 			console.error(err);
	// 		}
	// 	};
	// 	checkAffiliateStatus();
	// }, [onNext]);
	const newAff = async () => {
		if (!agreePolicy) {
			message.warning("Vui lòng đồng ý với điều khoản trước khi tham gia.");
			return;
		}

		try {
			setLoading(true);
			const user = JSON.parse(localStorage.getItem("user") || "{}");
			if (!user?.id) {
				message.error("Bạn cần đăng nhập trước khi tham gia chương trình affiliate.");
				return;
			}

			const res = await mixPostV1("/api/v1/fe/contact_affiliate/create", {
				customer_id: user.id,
			}, { auth: true });

			if (res?.status && res.data?.status === 1) {
				setShowAffiliateProgram(false);
				setShowRegistrationSuccessfulModal(true);
			} else if (res?.status && res.data?.status === 0) {
				message.warning("Yêu cầu của bạn đang chờ phê duyệt.");
			} else {
				message.error("Đã xảy ra lỗi.");
			}
		} catch (err) {
			message.error("Không thể gửi yêu cầu. Vui lòng thử lại.");
		} finally {
			setLoading(false);
		}
	};


	const setSuccess = () => {
		setShowRegistrationSuccessfulModal(false);
		onNext?.();
	}
	if (loadingProfile) return null;
	return (
		<div className="content-dashboard-profile">
			<div className="title-profile">
				<div className="title">Become a Partner</div>
				<div className="title-13 color-white1 pt-2 fw-normal">
					Introduce Bidai and earn commissions
				</div>
			</div>

			<div data-name="dashboard_two" className="mt-[16px] lqd-card text-card-foreground bg-card-background w-full transition-all group/card lqd-card-outline border border-card-border rounded-card">
				<div className="lqd-card-body relative only:grow lqd-card-lg py-8 px-10 max-sm:p-7">
					<h3 className="mb-6 flex items-center gap-3">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M18.7588 7.85618L17.1437 8.18336V8.18568C16.3659 8.34353 15.6517 8.72701 15.0905 9.28825C14.5292 9.8495 14.1458 10.5636 13.9879 11.3415L13.6607 12.9565C13.6262 13.1155 13.5383 13.2578 13.4117 13.3599C13.285 13.462 13.1273 13.5177 12.9646 13.5177C12.8019 13.5177 12.6442 13.462 12.5175 13.3599C12.3909 13.2578 12.303 13.1155 12.2685 12.9565L11.9413 11.3415C11.7837 10.5635 11.4003 9.84922 10.839 9.28793C10.2777 8.72663 9.56345 8.34324 8.78546 8.18568L7.17042 7.8585C7.00937 7.82552 6.86464 7.73795 6.76071 7.61058C6.65678 7.48321 6.60001 7.32386 6.60001 7.15946C6.60001 6.99507 6.65678 6.83572 6.76071 6.70835C6.86464 6.58098 7.00937 6.4934 7.17042 6.46043L8.78546 6.13324C9.56339 5.97554 10.2776 5.5921 10.8389 5.03084C11.4001 4.46957 11.7836 3.75536 11.9413 2.97743L12.2685 1.36239C12.303 1.20344 12.3909 1.06109 12.5175 0.959015C12.6442 0.856935 12.8019 0.80127 12.9646 0.80127C13.1273 0.80127 13.285 0.856935 13.4117 0.959015C13.5383 1.06109 13.6262 1.20344 13.6607 1.36239L13.9879 2.97743C14.1458 3.75529 14.5292 4.46943 15.0905 5.03067C15.6517 5.59192 16.3659 5.9754 17.1437 6.13324L18.7588 6.45811C18.9198 6.49108 19.0645 6.57866 19.1685 6.70603C19.2724 6.8334 19.3292 6.99275 19.3292 7.15714C19.3292 7.32154 19.2724 7.48089 19.1685 7.60826C19.0645 7.73563 18.9198 7.8232 18.7588 7.85618ZM6.94895 16.0393L6.51038 16.1286C5.96946 16.2383 5.47282 16.5037 5.08244 16.8939C4.69206 17.2841 4.42523 17.7806 4.31524 18.3214L4.2259 18.76C4.202 18.8835 4.13584 18.9949 4.03877 19.075C3.9417 19.1551 3.81978 19.1989 3.69394 19.1989C3.56809 19.1989 3.44617 19.1551 3.3491 19.075C3.25204 18.9949 3.18587 18.8835 3.16197 18.76L3.07263 18.3214C2.96278 17.7805 2.69599 17.2839 2.30559 16.8937C1.91518 16.5035 1.41847 16.237 0.877485 16.1274L0.43892 16.0381C0.315366 16.0142 0.203985 15.948 0.123895 15.851C0.0438042 15.7539 0 15.632 0 15.5061C0 15.3803 0.0438042 15.2584 0.123895 15.1613C0.203985 15.0642 0.315366 14.9981 0.43892 14.9742L0.877485 14.8848C1.41862 14.7752 1.91545 14.5085 2.30587 14.1181C2.69629 13.7276 2.96299 13.2308 3.07263 12.6897L3.16197 12.2511C3.18587 12.1276 3.25204 12.0162 3.3491 11.9361C3.44617 11.856 3.56809 11.8122 3.69394 11.8122C3.81978 11.8122 3.9417 11.856 4.03877 11.9361C4.13584 12.0162 4.202 12.1276 4.2259 12.2511L4.31524 12.6897C4.42482 13.231 4.69148 13.728 5.08189 14.1186C5.4723 14.5092 5.96915 14.7761 6.51038 14.886L6.94895 14.9753C7.0725 14.9992 7.18388 15.0654 7.26397 15.1625C7.34407 15.2595 7.38787 15.3814 7.38787 15.5073C7.38787 15.6331 7.34407 15.7551 7.26397 15.8521C7.18388 15.9492 7.0725 16.0154 6.94895 16.0393Z"
								fill="url(#paint0_linear_213_525)"
							></path>
							<defs>
								<linearGradient id="paint0_linear_213_525" x1="1.1976e-07" y1="4.55439" x2="15.5124" y2="18.9291" gradientUnits="userSpaceOnUse">
									<stop stop-color="#82E2F4"></stop>
									<stop offset="0.502" stop-color="#8A8AED"></stop>
									<stop offset="1" stop-color="#6977DE"></stop>
								</linearGradient>
							</defs>
						</svg>

						Hey, How can I help you?
					</h3>
					<form
						className="header-search relative transition-all group/header-search mb-0 w-full header-search-style-modern"
						x-data="liquidHeaderSearch"
					>
						<div className="header-search-input-wrap relative w-full">
							<div className="header-search-border pointer-events-none absolute -inset-1 overflow-hidden rounded-[calc(var(--input-rounded)*var(--input-rounded-multiplier)+0.25rem)] bg-heading-foreground/5">
								<div className="header-search-border-play absolute left-1/2 top-1/2 aspect-square min-h-full min-w-full -translate-x-1/2 -translate-y-1/2 rounded-[inherit]">
									<div className="header-search-border-play-inner absolute min-h-full min-w-full opacity-0"></div>
								</div>
							</div>

							<div className="lqd-input-container relative peer">
								<input
									onClick={() => toggleModal(true)}
									id=""
									className="lqd-input block peer w-full px-4 py-2 border border-input-border text-base ring-offset-0 focus:border-secondary focus:outline-0 focus:ring focus:ring-secondary dark:focus:ring-foreground/10 sm:text-2xs lqd-input-lg header-search-input transition-colors placeholder-shown:text-ellipsis bg-background border-none h-12 text-heading-foreground shadow-[0_4px_8px_rgba(0,0,0,0.05)] placeholder:text-heading-foreground"
									name=""
									value=""
									type="text"
									placeholder="Search for documents, templates, tools and more" />
							</div>

							<span className="header-search-loader absolute end-12 top-1/2 -translate-y-1/2" x-show="isSearching" style={{ display: 'none' }}>
								<svg stroke-width="1.5" role="status" className="animate-spin" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
									<path d="M12 3a9 9 0 1 0 9 9"></path>
								</svg>
							</span>
						</div>
					</form >

					{/* Modal overlay */}
					{modalOpen && (
						<div className="fixed inset-0 z-[999] flex items-center justify-center overflow-y-auto bg-black/30">
							{/* Bấm ra ngoài để đóng */}
							<div
								className="fixed inset-0"
								onClick={() => toggleModal(false)}
							></div>

							{/* Modal content */}
							<div
								className="relative z-[100] max-h-[95vh] min-w-[clamp(250px,760px,90vw)] max-w-[min(calc(100%-2rem),630px)] overflow-y-auto rounded-xl bg-white shadow-2xl"
								onClick={(e) => e.stopPropagation()} // chặn click bên trong
							>
								{/* Header input */}
								<div className="relative flex items-center justify-between border-b">
									<div className="relative flex w-full">
										<svg
											strokeWidth="1.5"
											className="pointer-events-none absolute start-4 top-1/2 z-10 size-5 -translate-y-1/2 text-gray-600"
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke="currentColor"
											fill="none"
											strokeLinecap="round"
											strokeLinejoin="round"
										>
											<path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
											<path d="M21 21l-6 -6"></path>
										</svg>

										<input
											className="header-search-input h-[70px] w-full bg-transparent ps-12 text-heading-foreground outline-none transition-colors placeholder:text-foreground placeholder-shown:text-ellipsis max-lg:rounded-md max-sm:text-base ps-14 pr-10"
											type="text"
											placeholder="Search for anything..."
											value={searchTerm}
											onChange={handleSearch}
										/>

										{isSearching && (
											<span className="absolute end-5 top-1/2 -translate-y-1/2">
												<svg
													strokeWidth="1.5"
													role="status"
													className="animate-spin text-gray-500"
													xmlns="http://www.w3.org/2000/svg"
													width="24"
													height="24"
													viewBox="0 0 24 24"
													stroke="currentColor"
													fill="none"
													strokeLinecap="round"
													strokeLinejoin="round"
												>
													<path d="M12 3a9 9 0 1 0 9 9"></path>
												</svg>
											</span>
										)}
									</div>

									{!isSearching && (
										<div className="pointer-events-none absolute end-5 top-1/2 flex -translate-y-1/2 whitespace-nowrap hidden sm:flex">
											<span className="text-xs text-gray-400">
												Templates, Documents, Bots and more
											</span>
										</div>
									)}
								</div>

								{/* Nội dung modal */}
								<div className="max-h-[min(440px,80vh)] overflow-y-auto rounded-xl bg-white shadow-inner">
									{searchTerm ? (
										<div className="p-6">
											<h3 className="text-base font-medium mb-4 border-b pb-2">
												Search results
											</h3>
											<p>Kết quả cho: <strong>{searchTerm}</strong></p>
										</div>
									) : (
										<div>
											<a
												className="lqd-btn group inline-flex items-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none w-full justify-between rounded-none border-b px-5 py-4 font-heading !text-base !font-medium text-heading-foreground"
												style={{ fontWeight: 'inherit' }}
												href="https://demo.magicproject.ai/dashboard/user/openai/documents/all"
											>
												Recently Launched
												<svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
													<path d="M9 6l6 6l-6 6"></path>
												</svg>
											</a>
											{/* <p className="text-gray-500 text-sm py-4 px-5">Không có tìm kiếm gần đây.</p> */}
											<div className="recent-lunched-container flex flex-col" x-html="recentLunchedDocs">
												<ul>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/gqZRp3Oadmin-admin-workbook">
															<span
																style={{ background: '#e3e49f' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/mDRivedadmin-admin-workbook">
															<span
																style={{ background: '#e3e49f' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/CUJb77Eadmin-admin-workbook">
															<span
																style={{ background: '#d1c5de' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm56-157h489L578 583 446 754l-93-127-117 152Z"></path>
																	</svg>
																</span>
															</span>
															upscale
															<small className="ms-auto text-foreground/50">Image</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/I5lWsOBadmin-admin-workbook">
															<span
																style={{ background: '#a3d6c2' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/lRpxiCyadmin-admin-workbook">
															<span
																style={{ background: '#a3d6c2' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/gqZRp3Oadmin-admin-workbook">
															<span
																style={{ background: '#e3e49f' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/mDRivedadmin-admin-workbook">
															<span
																style={{ background: '#e3e49f' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/CUJb77Eadmin-admin-workbook">
															<span
																style={{ background: '#d1c5de' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm56-157h489L578 583 446 754l-93-127-117 152Z"></path>
																	</svg>
																</span>
															</span>
															upscale
															<small className="ms-auto text-foreground/50">Image</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/I5lWsOBadmin-admin-workbook">
															<span
																style={{ background: '#a3d6c2' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
													<li className="border-b px-3 py-2 transition-colors last:border-b-0 hover:bg-foreground/5">
														<a className="flex items-center gap-2 text-heading-foreground" href="https://demo.magicproject.ai/dashboard/user/openai/documents/single/lRpxiCyadmin-admin-workbook">
															<span
																style={{ background: '#a3d6c2' }}
																className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all bg-primary text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-lg size-10"
															>
																<span className="flex size-5">
																	<svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
																		<path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554V236H220v680h520V422H551ZM220 236v186-186 680-680Z"></path>
																	</svg>
																</span>
															</span>
															Document
															<small className="ms-auto text-foreground/50">Document</small>
														</a>
													</li>
												</ul>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					)}
				</div >
			</div >

			<div className="d-flex flex-column gap-20 pt-4">
				<div className="affiliate-card">
					<div className="d-flex flex-column gap-20">
						<div className="d-flex flex-column gap-20">
							<strong className="color-white">Make it Rain with Bidai Referrals</strong>
							<div className="color-white-1">
								<div>Boost your bank account by joining our referral program</div>
								<div>How to Rake in the Rewards:</div>
								<br />
								<div>
									<strong>1. Join the Team:&nbsp;</strong>
									Apply in sec & get a confirmation email if you’re qualified.&nbsp;
								</div>
								<br />
								<div>
									<strong>2. Get Your Golden Ticket:&nbsp;</strong>
									Get your custom link & code and spread the word.
								</div>
								<br />
								<div>
									<strong>3. Share the Wealth, Stack the Cash:&nbsp;</strong>
									Watch the commissions roll in on your dashboard.
								</div>
								<br />
								<div>
									<strong className="color-white">Ready to make easy money?&nbsp;</strong>
									Share your link and let Bidai handle the rest.
								</div>
							</div>
						</div>

						<div className="d-flex align-items-center gap-9 mobile-flex-column">
							<button
								className="button button-primary"
								onClick={() => setShowAffiliateProgram(true)}
							>
								Join Partnership Program
							</button>
							<button
								className="button button-primary-outline"
								onClick={() => setShowAffiliatePolicyModal(true)}
							>
								Affiliate Policies
							</button>
						</div>
					</div>
				</div>

				<div className="affiliate-card">
					<div className="d-flex flex-column gap-40">
						<div className="d-flex flex-column gap-20">
							<strong className="color-white">Share Your Experience with Bidai!</strong>
							<div className="color-white-1">
								Enjoying Bidai? We'd love to hear from you! Submit your review and let
								others know how it’s helping you. Your feedback helps us improve and spread the
								word about Bidai!
							</div>

							<div className="d-flex flex-column">
								<strong className="color-white-1">Review us on:</strong>
								<div className="d-flex flex-wrap gap-20">
									<a href="#" className="color-primary text-underline">G2</a>
									<a href="#" className="color-primary text-underline">Capterra</a>
									<a href="https://www.producthunt.com/products/lazy-prompter" className="color-primary text-underline">Product Hunt</a>
								</div>
							</div>

							<div className="d-flex flex-column">
								<strong className="color-white-1">Join our community</strong>
								<div className="d-flex flex-wrap gap-20">
									<a href="https://www.facebook.com/groups/videocreativestationwithai" target="_blank" className="color-primary text-underline">Facebook Group</a>
									<a href="https://zalo.me/g/aiaptl157" target="_blank" className="color-primary text-underline">Zalo</a>
								</div>
							</div>

							<div className="d-flex flex-column">
								<strong className="color-white-1">Follow us on</strong>
								<div className="d-flex flex-wrap gap-20">
									<a href="https://www.facebook.com/mochimincom" target="_blank" className="color-primary text-underline">Facebook</a>
									<a href="https://www.youtube.com/@mochimin_ai" target="_blank" className="color-primary text-underline">Youtube</a>
									<a href="https://www.tiktok.com/@mochimin_ai" target="_blank" className="color-primary text-underline">Tiktok</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* MODALS */}
			<Modal
				open={showRegistrationSuccessfulModal}
				centered
				footer={null}
				closable={false}
				className="rs-modal modal-472 bg-1E1F20"
				onCancel={() => setShowRegistrationSuccessfulModal(false)}
			>
				<div className="d-flex flex-column gap-20 text-center align-items-center">
					<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M31.25 20.8333L22.9167 29.1667L18.75 25M25 43.75C14.6447 43.75 6.25 35.3553 6.25 25C6.25 14.6447 14.6447 6.25 25 6.25C35.3553 6.25 43.75 14.6447 43.75 25C43.75 35.3553 35.3553 43.75 25 43.75Z" stroke="#009E70" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					<div className="color-white font-700 title-32">Application Submitted</div>
					<div className="color-white1">We will contact you as soon as possible.</div>
					<button
						className="button t-button-primary"
						style={{ borderRadius: "10px" }}
						onClick={() => setSuccess()}
					>
						Back to Bidai
					</button>
				</div>
			</Modal>

			<Modal
				open={showAffiliatePolicyModal}
				centered
				title="Affiliate Policies"
				footer={null}
				closable
				className="rs-modal modal-868 policy-modal bg-1E1F20"
				onCancel={() => setShowAffiliatePolicyModal(false)}
				bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
			>
				<div className="color-white1 fw-normal">
					<p>Affiliate policy content goes here...</p>
				</div>
			</Modal>

			<Modal
				open={showAffiliateProgram}
				centered
				footer={null}
				closable={false}
				className="rs-modal modal-472 bg-1E1F20 modal-affiliate-program"
				onCancel={() => setShowAffiliateProgram(false)}
			>
				<div className="d-flex flex-column gap-20">
					<div className="color-white font-700 title-32 text-center">Affiliate program</div>
					<div className="content-modal color-white1">
						<div className="title-cotent policies">
							<div className="content-ovh-x">
								<div className="one-item">
									<div className="title">💲 Earning Potential</div>
									<div className="list">
										<div className="one-text">20% commission on all customer payments</div>
										<div className="one-text">Applies to initial purchases and renewals</div>
										<div className="one-text">Example: 100,000 VND sale yields 20,000 VND</div>
									</div>
								</div>
								<div className="one-item">
									<div className="title">📩 Onboarding Process</div>
									<div className="list">
										<div className="one-text">Submit application (7-day review)</div>
										<div className="one-text">Receive approval and unique link</div>
										<div className="one-text">Begin promotion and revenue generation</div>
									</div>
								</div>
							</div>
						</div>

						<div className="t-check-box">
							<label className="form-checkbox">
								<input type="checkbox" className="form-checkbox__input" checked={agreePolicy}
									onChange={(e) => setAgreePolicy(e.target.checked)} />
								<span className="form-checkbox__text">
									I agree to the policies, <a href="#">terms and conditions</a> of the partnership program.
								</span>
							</label>
						</div>

						<div className="buttom-block">
							<button
								onClick={newAff}
								className="button t-button-primary"
								style={{ borderRadius: "10px" }}
							>
								{loading ? (
									<div className="loader"></div>
								) : (
									<p>Join</p>
								)}
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default AffiliatePage;
